//ClientFooter.vue
<template>
  <footer>
    <a
      href="https://www.ziru-co.com"
      target="_blank"
      rel="noopener"
      class="footer-content"
    >
      <span class="text"
        >ZIRU - SOFTWARE DEVELOPMENT | © {{ currentYear }} جميع الحقوق
        محفوظة</span
      >
    </a>
  </footer>
</template>

<script>
export default {
  name: "ClientFooter",
  data() {
    return {
      currentYear: new Date().getFullYear(),
    };
  },
};
</script>

<style scoped>
footer {
  width: 100%;
  height: 50px;
  background-color: #f8f9fa;
  border-top: 1px solid #ddd;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-content {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  color: #555;
  font-size: 0.9rem;
  direction: ltr; /* ✅ إجبار النص على اليسار لليمين */
}

.footer-logo {
  height: 20px;
  object-fit: contain;
}
</style>
